/* Postrly product buy module v2 — size/frame pills + digital file card.
   Maps selections to the correct Shopify variant, syncs every product
   form's hidden id input, updates the inline selected-value labels, and
   broadcasts 'postrly:variant'. Vanilla JS, no deps. */
(function () {
  'use strict';
  var DIGITAL = 'Digital File Download';

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function init(root) {
    if (root.dataset.pbInit) return;
    root.dataset.pbInit = '1';
    var variants;
    try { variants = JSON.parse(root.querySelector('[data-pb-variants]').textContent); } catch (e) { return; }

    var sizeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pb-size]'));
    var frameBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pb-frame]'));
    var digitalBox = root.querySelector('[data-pb-digital]');
    var priceEl = root.querySelector('[data-pb-price]');
    var compareEl = root.querySelector('[data-pb-compare]');
    var sizeOut = root.querySelector('[data-pb-size-out]');
    var frameOut = root.querySelector('[data-pb-frame-out]');

    var state = {
      size: (sizeBtns.filter(function (b) { return b.classList.contains('is-on'); })[0] || sizeBtns[0] || { getAttribute: function () { return null; } }).getAttribute('data-pb-size'),
      frame: (frameBtns.filter(function (b) { return b.classList.contains('is-on'); })[0] || frameBtns[0] || { getAttribute: function () { return null; } }).getAttribute('data-pb-frame'),
      digital: false,
      prevSize: null, prevFrame: null
    };

    function find(o1, o2) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].o1 === o1 && (o2 === null || variants[i].o2 === o2)) return variants[i];
      }
      return null;
    }
    function resolve() {
      if (state.digital) return find(DIGITAL, null);
      return find(state.size, state.frame) || find(state.size, null);
    }

    function syncForms(variant) {
      if (!variant) return;
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (input) {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function paintPills(list, key, selected) {
      list.forEach(function (b) {
        var on = b.getAttribute(key) === selected;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    function availabilityPass() {
      sizeBtns.forEach(function (b) {
        var v = find(b.getAttribute('data-pb-size'), state.frame);
        b.disabled = !(v && v.available);
      });
      frameBtns.forEach(function (b) {
        var v = find(state.size, b.getAttribute('data-pb-frame'));
        b.disabled = !(v && v.available);
      });
    }

    function apply() {
      var v = resolve();
      if (!v) return;
      root.classList.toggle('is-digital', state.digital);
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare && v.compare > v.price) { compareEl.hidden = false; compareEl.textContent = money(v.compare); }
        else compareEl.hidden = true;
      }
      if (sizeOut) sizeOut.textContent = '· ' + (state.digital ? 'Digital file' : state.size);
      if (frameOut) frameOut.textContent = state.digital ? '' : '· ' + state.frame;
      paintPills(sizeBtns, 'data-pb-size', state.size);
      paintPills(frameBtns, 'data-pb-frame', state.frame);
      availabilityPass();
      syncForms(v);
      document.dispatchEvent(new CustomEvent('postrly:variant', { detail: { variant: v, digital: state.digital } }));
    }

    root.addEventListener('click', function (e) {
      var s = e.target.closest('[data-pb-size]');
      var f = e.target.closest('[data-pb-frame]');
      if (s && !s.disabled && !state.digital) { state.size = s.getAttribute('data-pb-size'); apply(); }
      if (f && !f.disabled && !state.digital) { state.frame = f.getAttribute('data-pb-frame'); apply(); }
    });

    if (digitalBox) {
      digitalBox.addEventListener('change', function () {
        if (digitalBox.checked) {
          state.prevSize = state.size; state.prevFrame = state.frame;
          state.digital = true;
        } else {
          state.digital = false;
          if (state.prevSize) state.size = state.prevSize;
          if (state.prevFrame) state.frame = state.prevFrame;
        }
        apply();
      });
    }

    apply();
  }

  function scan() { document.querySelectorAll('[data-postrly-buy]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
